/* unplugin-vue-components disabled */import script from "./LoginDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginDialog.vue?vue&type=script&setup=true&lang=js"

import "./LoginDialog.vue?vue&type=style&index=0&id=ca34958e&lang=stylus"

const __exports__ = script;

export default __exports__